<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">
            <div class="logo-container">
              <img class="logo-icon-essilor" src="../../assets/logo-icon-essilor-white.svg" />
              <img src="../../assets/logo-essi-expert.svg" />
            </div>
            <h2>Bienvenue dans votre nouvel outil digital de démonstration verres Essilor !</h2>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <div class="message">
              <p v-if="hasFullService">
                Afin de poursuivre l’utilisation de l’outil digital Essi’Expert, merci de prendre connaissance et
                d’accepter des conditions générales d’utilisation en cochant la case ci-dessous.
              </p>
              <p v-if="!hasFullService">
                Afin de poursuivre l’utilisation de l’outil digital Essi’Expert, les conditions générales d'utilisation
                de l'outil doivent être validées.
                <br />Aussi, nous vous remercions de prendre contact avec le propriétaire du magasin afin qu'il puisse
                accepter ces C.G.U. avec son profil propriétaire essilorpro.fr commençant par «99»
              </p>
            </div>
            <div v-if="hasFullService" class="content-with-error">
              <div class="valid-cgu">
                <input v-model="isValidated" v-on:click="displayError = false" type="checkbox" id="accept-cgu" />
                <label @click="openCGU">J’accepte les conditions générales d’utilisation</label>
              </div>
              <p v-if="displayError" class="error-message">
                Merci d’accepter les conditions générales d’utilisation pour utiliser Essi’Expert
              </p>
            </div>
            <div v-if="hasFullService" class="button-valid" v-on:click="validated()">Découvrir Essi’Expert</div>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <img width="100" src="../../assets/logo-marque/essilor.png" />
            <p>Tous droits réservés © 2020 - Essilor</p>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalCgu',
  props: ['hasFullService'],
  methods: {
    close() {
      this.$emit('close');
    },
    openCGU() {
      this.$emit('openCGU');
    },
    validated() {
      if (!this.isValidated) {
        this.displayError = true;
      } else {
        this.close();
      }
    },
  },
  data: () => {
    return {
      displayError: false,
      isValidated: false,
    };
  },
};
</script>

<style scoped>
.modal-backdrop {
  z-index: 2000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  width: 40%;
  min-width: 750px;
  height: 90%;
  background: #ffffff;
  overflow-x: auto;
  border: solid 2px #0042C3;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  color: black;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container img:last-child {
  height: 54px;
}

.logo-icon-essilor {
  height: 48px;
  background-color: #0042C3;
  padding: 10px;
  border-radius: 50%;
  margin-right: 20px;
}

.modal-header h2 {
  padding-top: 40px;
  font-size: 20px;
}

.modal-footer {
  align-items: center;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  padding: 20px 10%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.btn-close {
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-close img {
  width: 30px;
  filter: invert(16%) sepia(99%) saturate(2601%) hue-rotate(215deg) brightness(96%) contrast(108%);
}

.logo-close {
  border: solid 2px black;
  border-radius: 24px;
}

.message {
  border: solid 2px #0042C3;
  padding: 2% 1%;
}

/*
  Custom checkbox
*/
input[type='checkbox'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  height: 30px;
  width: 30px;
  background: #fff;
  border: 2px solid #0042C3;
}

input[type='checkbox']:checked {
  position: relative;
}

input[type='checkbox']:checked~.checkbox-label {
  border-bottom: 1px solid #0042C3;
  padding-bottom: 2px;
}

input[type='checkbox']:checked:after {
  content: '';
  position: absolute;
  left: 30%;
  top: 8%;
  border: 2px solid #0042C3;
  border-top: 0;
  border-left: 0;
  width: 10px;
  height: 20px;
  transform: rotate(45deg);
}

label {
  margin-left: 10px;
}

.valid-cgu:hover label {
  border-bottom: 1px solid black;
  cursor: pointer;
}

.valid-cgu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-valid {
  outline: none;
  cursor: pointer;
  font-size: 24px;
  color: white;
  padding: 20px 0;
  background-color: #0042C3;
  border-radius: 8px;
  margin: 0 30%;
  -moz-box-shadow: 1px 1px 5px 0px black;
  -webkit-box-shadow: 1px 1px 5px 0px black;
  box-shadow: 1px 1px 5px 0px black;
  font-weight: bolder;
}

.button-valid::selection {
  background: none;
}

.error-message {
  color: red;
  font-style: italic;
}
</style>
